<!-- <p-dialog #dialog [header]="file?.fileName" styleClass="vs-modal force-full-width file-viewer" [showHeader]="false" positionBottom="0" positionTop="0" [(visible)]="showFileDialog" [style]="{'bottom':'0'}" [contentStyle]="{'height': '100vh'}" [modal]="true" [maximizable]="true" appendTo="body"> -->
    <div class="gallery-wrapper">
        <!-- Top Navigation Bar -->
        <div class="top-bar">
            <div class="file-info">
                <span class="file-name">{{file?.fileName}}</span>
                <span class="file-counter" *ngIf="listFile?.length > 0">{{selectedIndex + 1}} / {{listFile.length}}</span>
            </div>
            
            <div class="top-bar-actions">
                <div class="floating-controls">
                    <button class="control-btn" pTooltip="Xoay trái" (click)="rotateImage(-90)">
                        <i class="fa fa-undo"></i>
                    </button>
                    <button class="control-btn" pTooltip="Xoay phải" (click)="rotateImage(90)">
                        <i class="fa fa-redo"></i>
                    </button>
                    <div class="zoom-info">{{ scale | number:'1.0-0' }}%</div>
                </div>
                
                <button class="btn-close-gallery" (click)="closePopup()" pTooltip="Đóng">
                    <i class="pi pi-times"></i>
                </button>
            </div>
        </div>

        <!-- Main Content Area -->
        <div class="gallery-content">
            <!-- Left Arrow -->
            <button *ngIf="listFile?.length > 0" class="nav-btn prev-btn" (click)="onPrev()">
                <i class="pi pi-chevron-left"></i>
            </button>

            <!-- Video Content -->
            <div *ngIf="file.type == fileType.Video" class="media-container">
                <video controls autoplay name="media" class="media-video">
                    <source [src]="file?.link" type="video/{{file.extention.replace('.','')}}">
                </video>
            </div>

            <!-- Image Content -->
            <div *ngIf="file.type == fileType.Image" class="media-container" #container>
                <div class="image-wrapper" (mousedown)="onMouseDown($event, image)" (mousemove)="onMouseMove($event)" (mouseup)="onMouseUp()">
                    <img #image [src]="getImageOriginal(file?.id)" [class.dragging]="dragging"
                        [ngStyle]="{ transform: 'scale(' + scale / 100 + ') translate(' + offsetX + 'px, ' + offsetY + 'px) rotate(' + rotation + 'deg)',
                        'transform-origin': 'center center'}" draggable="false" class="media-image">
                </div>
                
            </div>

            <!-- Right Arrow -->
            <button *ngIf="listFile?.length > 0" class="nav-btn next-btn" (click)="onNext()">
                <i class="pi pi-chevron-right"></i>
            </button>
        </div>

        <!-- Thumbnail Strip -->
        <div class="thumbnail-strip" *ngIf="listFile?.length > 0">
            <div class="thumb-container">
                <div *ngFor="let item of listFile; let idx = index" class="thumb-item" 
                    [ngClass]="{'active': idx === selectedIndex}" 
                    (click)="getCurrent(item, idx)" (contextmenu)="openPopup($event, item)">
                    <!-- thumbnail image -->
                    <img *ngIf="item.type == fileType.Image" [src]="getImageAvatar(item.id)">
                    <div *ngIf="item.type == fileType.Video" class="thumb-video-icon">
                        <i class="pi pi-play"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>

<!-- </p-dialog> -->